import React from 'react'

import Page from '../../../components/Page'
import UserGroupsList from './UserGroupsList'
import withAuth from '../../../components/withAuth'

const GroupSharing = () => {
	return (
		<Page title="User Groups" isFullWidth>
			<div className="pl-5 pr-5 pb-10 pt-10 h-full">
				<UserGroupsList />
			</div>
		</Page>
	)
}

export default withAuth(GroupSharing)
